import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FuseNavigationItem, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { fullCompactNavigation } from '../../../core/navigation/navigation';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart, RouterLink, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseLoadingBarComponent } from '../../../../../../shared/src/lib/@fuse/components/loading-bar/loading-bar.component';
import { FuseFullscreenComponent } from '../../../../../../shared/src/lib/@fuse/components/fullscreen/fullscreen.component';

@Component({
    selector: 'compact-layout',
    templateUrl: './compact.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [FuseLoadingBarComponent, FuseVerticalNavigationComponent, NgIf, MatIconModule, MatButtonModule, FuseFullscreenComponent, RouterOutlet, RouterLink],
})
export class CompactLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: FuseNavigationItem[];
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    title = '';

    /**
     * Constructor
     */
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {
        // this.store.pipe(takeUntil(this._unsubscribeAll)).subscribe(store => {
            this.navigation = fullCompactNavigation;
        // });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        if (this.activatedRoute.firstChild && this.activatedRoute.firstChild.snapshot.data['title']) {
            this.title = this.activatedRoute.firstChild.snapshot.data['title'];
        }
        this.router
            .events.pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => {
                    const child = this.activatedRoute.firstChild;
                    if (child.snapshot.data['title']) {
                        return child.snapshot.data['title'];
                    }
                    return '';
                })
            ).subscribe((title: string) => {
                    this.title = title;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

}
